import React from 'react';
import { LoadOptions } from 'ui';
import * as navigate from 'app/area/shared/navigation';
import { routeConstants } from 'app/routes/route-constants';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { CodetableOptions } from 'app/area/codetable/common';
import { AddCodeModal } from 'app/area/codetable/list/list-items/add-code-modal';
import { ButtonComponentProps } from 'app/area/codetable/list/list-renderer/types';

interface UserGroupCodeModalProps {
  label: string;

  codetableId: number;
  breadcrumbs: number[];
  parentId: number;

  codetableOptions: { [key: string]: CodetableOptions };
  loadCodetableOptions: (id: string, codetableId: number, loadOptionsParams: LoadOptions) => void;

  ButtonComponent: ButtonComponentProps;

  translation: CodetableTranslation;
}

const userGroupKey = 'userGroup';

export class UserGroupCodeModal extends React.Component<UserGroupCodeModalProps> {
  private handleAddDuplicate = (duplicateId: number) => {
    const { breadcrumbs, parentId } = this.props;
    navigate.to({
      pathname: routeConstants.codetableAdministrationDuplicateCodeFor(breadcrumbs, duplicateId, parentId)
    });
  };

  private handleAddEmpty = () => {
    const { breadcrumbs, parentId } = this.props;
    navigate.to({
      pathname: routeConstants.codetableAdministrationAddCodeFor(breadcrumbs, parentId)
    });
  };

  private loadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    const { codetableId, loadCodetableOptions } = this.props;

    loadCodetableOptions(id, codetableId, loadOptionsParams);
  };

  public render() {

    const { label, codetableOptions, ButtonComponent, translation } = this.props;

    return <AddCodeModal
      id={'codetable-list-link-create-modal'}
      buttonText={label}
      labelText={translation.user_group}
      dropdownLabelText={translation.copy_from_user_group}
      actionText={translation.create_empty_user_group}
      submitText={translation.done}
      submit={this.handleAddDuplicate}
      onAction={this.handleAddEmpty}
      pickerId={userGroupKey}
      codes={codetableOptions?.[userGroupKey]?.codes ?? []}
      fetching={codetableOptions?.[userGroupKey]?.fetching ?? false}
      loadOptions={this.loadOptions}
      ButtonComponent={ButtonComponent}
      translation={translation}
    />;
  }
}
